import useAuth from 'portal/src/auth/useAuth';
import { IPageProps } from 'portal/src/layouts/LayoutPreference/layoutTypes';
import Page from 'portal/src/layouts/Page';
import unauthorizedResponse from 'portal/src/navigation/responses/unauthorizedResponse';

const SystemAdministrationPage = (props: IPageProps) => {
  const { hasClientSystemAdminAccess } = useAuth();

  if (!hasClientSystemAdminAccess()) {
    throw unauthorizedResponse();
  }

  return <Page {...props} />;
};

export default SystemAdministrationPage;
